export default __webpack_public_path__ + "static/media/benefit-1.75339e18.png";